import { useState, useEffect, useCallback } from 'react';
/**
 * Custom hook to get ref
 */
export const useMapRef = () => {
    const [map, setMap] = useState(null);
    const mapRef = useCallback(map => {
        setMap(map);
    }, []);
    return [map, mapRef];
};
/**
 * Custom hook to get map apis when style is ready and map loaded
 * @param map - Mapbox API
 */
export const useMapWhenReady = map => {
    const [mapApi, setMapApi] = useState(null);
    const [isMapStyleReady, mapStyleReady] = useState(false);
    const mapLoaded = () => {
        if (mapApi && mapApi.isStyleLoaded()) {
            mapStyleReady(true);
        }
    };
    useEffect(() => {
        if (map) {
            setMapApi(map.getMap());
        }
    }, [map]);
    return {
        mapApis: mapApi && isMapStyleReady ? mapApi : null,
        mapLoaded,
    };
};
export const isWithinSnapBoundaries = (lngLat1, snapPoint, pixelOffset, mapApis) => {
    const point = mapApis.project(lngLat1);
    if (point.x >= snapPoint.x - pixelOffset &&
        point.x <= snapPoint.x + pixelOffset &&
        point.y >= snapPoint.y - pixelOffset &&
        point.y <= snapPoint.y + pixelOffset) {
        return true;
    }
    else {
        return false;
    }
};
//# sourceMappingURL=maps.js.map